exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-item[data-v-3ffc5710] :active,.news-item[data-v-3ffc5710]:hover{background-color:var(--c-footer-bg);color:#fff}.news-item a[data-v-3ffc5710]{margin:10px auto;padding:10px;display:-ms-flexbox;display:-webkit-box;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.news-item a[data-v-3ffc5710]:visited{color:#000}.news-item img[data-v-3ffc5710]{max-width:80px;max-height:100px;-o-object-fit:contain;object-fit:contain;margin-right:20px}.news-item__info-container[data-v-3ffc5710]{width:300px}.news-item__small-text[data-v-3ffc5710]{font-size:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ffc5710","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NewsItem.vue
// module id = 276
// module chunks = 0